module.exports = __webpack_public_path__ + "static/media/facebook.5c376c48.svg";